import React from "react";
import { HelperText } from "react-native-paper";
import { OutlinedInput } from "./OutlinedInput";
import { useTranslation } from "react-i18next";

import {Field} from "../../config/companies/config";

interface NumberFieldProps {
  field: Field;
  value: number;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: { [key: string]: string };
}

export const NumberField = ({
  field,
  value,
  onChange,
  errors = {},
}: NumberFieldProps) => {
  const { t } = useTranslation();

  const handleChangeNumber = (text: string) => {
    onChange(field.name, text === "" ? 0 : parseInt(text));
  };

  const label = t(field.label) + (field.required ? "*" : "");

  return (
    <>
      <OutlinedInput
        testID={`number-${field.label}`}
        label={label}
        value={value.toString()}
        onChangeText={handleChangeNumber}
        keyboardType="numeric"
        error={!!errors[field.name]}
        autoFocus={field.autoFocus}
      />
      {errors?.[field.name] && (
        <HelperText type="error">{t(errors[field.name])}</HelperText>
      )}
    </>
  );
};
